import classnames from 'classnames';
import React from 'react';

import useCardView from '../../../hooks/useCardView';
import Link from '../../Generic/Link/Link';
import EnergyLabelSvg from './EnergyLabelSvg';
import TRANSLATIONS from './translations@default.json';

const EnergyRatingText = ({ MaxEnergyRating }) => {
	const { isGridView } = useCardView();

	return (
		<div
			className={classnames(
				'flex sm:block md:flex flex-wrap font-headline text-body-xs',
				{
					'md:flex-col': isGridView,
				}
			)}>
			<span className="pr-1">
				{MaxEnergyRating === 'A'
					? TRANSLATIONS.newEnergyRating2021
					: TRANSLATIONS.oldEnergyRating}
			</span>

			<Link
				dataTag="energy rating message learn more"
				url={TRANSLATIONS.link}
				classes="text-caption text-cta-action"
				text={TRANSLATIONS.learnMore}
				OpenInNewWindow
			/>
		</div>
	);
};

const NewEnergyInformation = ({ energyRatingDetails, classes }) => {
	if (!energyRatingDetails) {
		return null;
	}

	const { FormerEnergyRating, MaxEnergyRating } = energyRatingDetails;

	return (
		<div className={`${classes} mt-3 flex flex-col`}>
			<div className="flex flex-col md:flex-row items-baseline md:items-center text-body-xs">
				<EnergyLabelSvg
					classes="pr-2"
					energyRatingDetails={energyRatingDetails}
				/>
				{FormerEnergyRating && (
					<span>
						{TRANSLATIONS.wasRated}{' '}
						<span className="font-bold pl-1">{FormerEnergyRating}</span>
					</span>
				)}
			</div>
			<EnergyRatingText MaxEnergyRating={MaxEnergyRating} />
		</div>
	);
};

export default NewEnergyInformation;
